import { render, staticRenderFns } from "./TextType.vue?vue&type=template&id=f831d49e&scoped=true&"
import script from "./TextType.vue?vue&type=script&lang=js&"
export * from "./TextType.vue?vue&type=script&lang=js&"
import style0 from "./TextType.vue?vue&type=style&index=0&id=f831d49e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f831d49e",
  null
  
)

export default component.exports